<div class="field field-typeahead-small position-relative" [class.valid]="model">
  @if (label) {
    <span class="label">{{label}} @if (optionalString) {
      <span>({{optionalString}})</span>
    }</span>
  }
  <input id="typeahead-prevent-manual-entry_{{index}}"
    type="text"
    [class.error-field]="error"
    [placeholder]="placeholder"
    [(ngModel)]="model"
    (blur)="onBlur()"
    (selectItem)="onSelect($event)"
    [ngbTypeahead]="search"
    [inputFormatter]="formatter"
    [resultFormatter]="formatter"
    [resultTemplate]="template"
    (change)="change($event)"
    (keyup.enter)="enter.emit()"
    [editable]="editable" />
  @if (error) {
    <span class="error-field-display">{{error}}</span>
  }

  <ng-template #template let-r="result" let-t="term">
    <ngb-highlight [result]="r.value" [term]="t"></ngb-highlight>
    @if (afterARR && afterARR.length) {
      <div class="typeahead-after">
        @for (item of afterARR; track item; let $i = $index) {
          @if (r[item]) {
            {{r[item]}}{{$i !== afterARR.length-1 ? ' - ' : ''}}
          }
        }
      </div>
    }
  </ng-template>

</div>